// test1748
(1748 && 0);
